import React, { Component } from "react";
import ProjectHeader from "../Components/ProjectHeader";
import backProject from "../Data/backend-projects";
import frontProject from "../Data/frontend-projects";
import fullProject from "../Data/fullstack-projects";
import ScrollToTop from "../Utils/ScrollToTop";

import { 
  IoLogoJavascript, 
  IoLogoHtml5,
  IoLogoCss3,
  IoLogoReact,
} from "react-icons/io5";

import {
  SiRedux,
  SiJest,
  SiTestinglibrary,
  SiMocha,
} from "react-icons/si";

import { FaBootstrap } from "react-icons/fa";
import ProjectHome from "../Components/ProjectHome";

export default class ProjectDetails extends Component {
  constructor() {
    super();

    this.state = {
      projects: [],
    };
  }

  componentDidMount() {
    this.setState({
      projects: [...frontProject, ...backProject, ...fullProject]
    })
  }

  render() {
    const { history } = this.props;
    const { pathname } = history.location;
    const { projects } = this.state;

    const recipesAppSkills = [
      <IoLogoHtml5 className="skill-icon" color="#f06529" />,
      <IoLogoCss3 className="skill-icon" color="#2965f1"/>,
      <IoLogoJavascript className="skill-icon" color="#F0DB4F"/>,
      <IoLogoReact className="skill-icon" color="#61DBFB" />,
      <SiRedux className="skill-icon" color="#764abc" />,
      <FaBootstrap className="skill-icon" color="#6610f2"/>,
      <SiJest className="skill-icon" color="#C63D14"/>,
      <SiMocha className="skill-icon" color="#8D6748"/>,
      <SiTestinglibrary className="skill-icon" color="#fa383e"/>,
    ];
    const recipesApp = pathname.includes('recipes-app');
    let skillsList;
    let project;

    if (projects.length) {
      const getProject = projects.find(({ name }) => pathname.includes(name));
    
      skillsList = getProject.skills.icon;
      project = getProject

      if (recipesApp) skillsList = recipesAppSkills;
    }

    return (
      <>
        <ScrollToTop />
        <ProjectHeader history={ history } skills={ skillsList } />
        <ProjectHome project={ project } recipesApp={ recipesApp } />
      </>
    )
  }
} 